<template>
	<div class="ks-progress-linear" :class="classes" :style="containerStyle">
		<div v-if="bufferValue < 100" class="ks-progress-linear-background" :style="backgroundStyle"></div>
		<div v-if="bufferValue < 100" class="ks-progress-linear-buffer" :style="bufferStyle"></div>
		<div class="ks-progress-linear-bar" :style="barStyle"></div>
		<div v-if="$slots.default" class="ks-progress-linear-content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		"value": {
			type: Number,
			default: 0
		},
		"bufferValue": {
			type: Number,
			default: 100
		},
		"height": {
			type: [Number, String],
			default: 4
		},
		"color": {
			type: String,
			default: "accent"
		},
		"backgroundColor": {
			type: String,
			default: ""
		},
		"indeterminate": {
			type: Boolean,
			default: false
		},
		"striped": {
			type: Boolean,
			default: false
		},
		"rounded": {
			type: Boolean,
			default: false
		},
		"active": {
			type: Boolean,
			default: true
		},
		"outlined": {
			type: Boolean,
			default: false
		}
	},
	computed: {
		"classes" () {
			return {
				"ks-progress-linear-indeterminate": this.indeterminate,
				"ks-progress-linear-striped": this.striped,
				"ks-progress-linear-rounded": this.rounded,
				"ks-progress-linear-inactive": !this.active,
				"ks-progress-linear-outlined": this.outlined
			}
		},
		"containerStyle" () {
			var h = typeof this.height === "number" ? this.height + "px" : this.height;
			return { height: h }
		},
		"barStyle" () {
			var style = { width: this.clampedValue + "%" }
			style.background = this.getColor(this.color)
			return style
		},
		"bufferStyle" () {
			return { width: this.clampedBuffer + "%" }
		},
		"backgroundStyle" () {
			var style = {}
			if (this.backgroundColor) {
				style.background = this.getColor(this.backgroundColor)
			}
			return style
		},
		"clampedValue" () {
			return Math.max(0, Math.min(100, this.value))
		},
		"clampedBuffer" () {
			return Math.max(0, Math.min(100, this.bufferValue))
		}
	},
	methods: {
		getColor (color) {
			var map = {
				"accent": "var(--ks-col-accent)",
				"success": "var(--ks-col-success)",
				"danger": "var(--ks-col-danger)",
				"warning": "var(--ks-col-warning)",
				"info": "var(--ks-col-info)"
			}
			return map[color] || color
		}
	}
}
</script>

<style>
.ks-progress-linear {
	position: relative;
	width: 100%;
	overflow: hidden;
	background: var(--ks-grey-4);
	border-radius: 999em;
	transition: height 0.2s ease;
}

.ks-progress-linear-rounded {
	border-radius: 999em;
}
.ks-progress-linear-rounded .ks-progress-linear-bar {
	border-radius: 999em;
}

.ks-progress-linear-inactive {
	opacity: 0;
	transition: opacity 0.3s ease;
}

/* Outlined */
.ks-progress-linear-outlined {
	background: transparent;
	border: 1px solid var(--ks-grey-4);
}

/* Background (behind buffer) */
.ks-progress-linear-background {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: var(--ks-grey-4);
}

/* Buffer */
.ks-progress-linear-buffer {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	background: var(--ks-grey-5);
	transition: width 0.3s ease;
}

/* Progress bar */
.ks-progress-linear-bar {
	position: relative;
	height: 100%;
	transition: width 0.3s ease;
}

/* Content overlay */
.ks-progress-linear-content {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 11px;
	color: var(--ks-font-color);
}

/* Striped */
.ks-progress-linear-striped .ks-progress-linear-bar {
	background-image: linear-gradient(
		45deg,
		rgba(255, 255, 255, 0.1) 25%,
		transparent 25%,
		transparent 50%,
		rgba(255, 255, 255, 0.1) 50%,
		rgba(255, 255, 255, 0.1) 75%,
		transparent 75%,
		transparent
	);
	background-size: 20px 20px;
}

/* Indeterminate */
.ks-progress-linear-indeterminate .ks-progress-linear-bar {
	width: 50% !important;
	animation: ks-progress-indeterminate 1.5s ease-in-out infinite;
}

@keyframes ks-progress-indeterminate {
	0% {
		transform: translateX(-100%);
	}
	60% {
		transform: translateX(200%);
	}
	100% {
		transform: translateX(200%);
	}
}
</style>
